import { createAction } from 'redux-actions'

export const getRequest = createAction('GET_STORAGES_REQUEST')
export const getSuccess = createAction('GET_STORAGES_SUCCESS')
export const getFailed = createAction('GET_STORAGES_FAILED')

export const resetState = createAction('RESET_STORAGES')
